import { Form } from "@pankod/refine-antd";
import { ResultType } from "./ResultType";
import { CloseCircleFilled, PlusOutlined } from "@ant-design/icons";
import { FormListFieldData } from "antd/es/form/FormList";
import React from "react";
import { DataType } from "types/challenge";
import { css } from "@emotion/react";

interface ListResultProps {
  field: FormListFieldData;
  diff_name: any[];
}
export const ListResult: React.FC<ListResultProps> = ({ field, diff_name }) => {
  const type_name =
    diff_name.length > 1 ? ["diff_stats", ...diff_name, field.name, "data_type"] : ["stats", field.name, "data_type"];
  const type = Form.useWatch(type_name);
  const onlyOneOption = [DataType["Yes/No"], DataType.Date, DataType.FreeText];
  return (
    <Form.List name={[field.name, "results", type]}>
      {(fieldsR, { add: addR, remove: removeR }, { errors: errorsR }) => (
        <div>
          {fieldsR.map((fieldR) => {
            return (
              <div key={fieldR.key} className="relative border-solid border-2 border-gray-200 rounded p-2 mt-2">
                <ResultType field={field} fieldR={fieldR} type={type} />
                <CloseCircleFilled
                  className="absolute right-[5px] top-[10px] text-red-400 text-[20px] cursor-pointer"
                  onClick={() => {
                    removeR(fieldR.name);
                  }}
                />
              </div>
            );
          })}
          <p className="flex justify-end h-[22px] text-red-700">{errorsR}</p>

          {((Boolean(type) && !onlyOneOption.includes(type)) ||
            (onlyOneOption.includes(type) && fieldsR.length === 0)) && (
              <div>
                  <p css={css`
                    color: #d32f2f;
                    font-size: 0.9rem;
                    font-style: italic;
                    `}>Click the button to enter responses and complete the task
                  </p>
                {/* <div onClick={() => addR()} className="cursor-pointer flex justify-end">
                  <PlusOutlined className="mr-2" />
                  Add response
                </div> */}
                <div className="flex justify-end">
                  <div
                    onClick={() => addR()}
                    className="cursor-pointer flex items-center justify-center px-4 py-2 rounded-lg shadow transition-colors"
                    style={{
                      backgroundColor: "#d95d01",
                      color: "white",
                      width: "40%",
                      transition: "background-color 0.2s ease-in-out",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e67628")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#d95d01")}
                  >
                    <PlusOutlined className="mr-2" />
                    Add response
                  </div>
                </div>

              </div>
          )}
        </div>
      )}
    </Form.List>
  );
};
